import { memo } from 'react'
import { usePress } from '@react-aria/interactions'
import cn from 'classnames'

import { Icon } from '~/shared/ui/Icon'
import { HStack } from '~/shared/ui/HStack'

import { BUTTON_HEIGHT, BUTTON_ICON_SIZE, BUTTON_SPINNER_SIZE } from './config'
import type { ButtonProps } from './types'

import styles from './Button.module.scss'

/** Главная кнопка продукта: 4 variant × 3 size, спека 01 §4. */
export const Button = memo(function Button(props: ButtonProps) {
  const {
    variant = 'PRIMARY',
    size = 'M',
    width = 'FULL',
    text,
    iconName,
    iconPosition = 'LEFT',
    isLoading = false,
    isDisabled = false,
    onPress,
  } = props

  const isEffectivelyDisabled = isDisabled || isLoading
  const { pressProps, isPressed } = usePress({ onPress, isDisabled: isEffectivelyDisabled })

  const icon = isLoading ? (
    <span
      className={styles.spinner}
      style={{ width: BUTTON_SPINNER_SIZE, height: BUTTON_SPINNER_SIZE }}
    />
  ) : (
    iconName && <Icon name={iconName} size={BUTTON_ICON_SIZE} />
  )

  return (
    <button
      className={cn(styles.root, styles[`variant_${variant}`], styles[`width_${width}`])}
      type='button'
      data-pressed={isPressed}
      aria-disabled={isEffectivelyDisabled || undefined}
      aria-busy={isLoading || undefined}
      style={{ height: BUTTON_HEIGHT[variant][size] }}
      {...pressProps}
    >
      <HStack gap='SMALL_S' justify='CENTER'>
        {icon && iconPosition === 'LEFT' && icon}
        <span className={styles.text}>{text}</span>
        {icon && iconPosition === 'RIGHT' && icon}
      </HStack>
    </button>
  )
})
